module.exports = {
  "account_page": [
    {
      "language": "nb-NO",
      "slug": "/account",
      "robots": "index,follow"
    },
    {
      "language": "en-US",
      "slug": "/en-US/account",
      "robots": "index,follow"
    }
  ],
  "shopping_cart_page": [
    {
      "language": "nb-NO",
      "slug": "/handlekurv",
      "robots": "index,follow"
    },
    {
      "language": "en-US",
      "slug": "/en-US/shopping-cart",
      "robots": "index,follow"
    }
  ],
  "not_found_page": [
    {
      "language": "nb-NO",
      "slug": "/not-found",
      "robots": "index,follow"
    },
    {
      "language": "en-US",
      "slug": "/en-US/not-found",
      "robots": "index,follow"
    }
  ]
}